<template>
  <div>
    <paper-modal-container :is-visible="true" :title="paperModalTitle" @close="goBack">
      <div class="form-wrapper">

        <section class="form-section-block">
          <div class="section-header">
            <h2 class="section-title">공연 기본정보</h2>
            <p class="section-description">안내 중인 공연입니다</p>
          </div>
          <div class="info-box">
            <div class="info-row">
              <span class="info-label">공연명</span>
              <span class="info-value">{{ liveTitle || "—" }}</span>
            </div>
            <div v-if="liveDateText" class="info-row">
              <span class="info-label">공연일시</span>
              <span class="info-value">{{ liveDateText }}</span>
            </div>
          </div>
        </section>

        <!-- <section class="form-section-block">
          <div class="section-header">
            <h2 class="section-title">예매 진행 안내</h2>
            <p class="section-description">
              아래 내용을 확인한 뒤 홈 또는 공연 페이지로 이동할 수 있습니다.
            </p>
          </div>
        </section> -->

        <div class="preview-notice">
          <span class="preview-notice-icon">{{ noticeIcon }}</span>
          <div class="preview-notice-content">
            <span class="preview-notice-label">{{ noticeLabel }}</span>
            <p class="preview-notice-text">{{ headline }}</p>
            <p class="preview-notice-detail">{{ description }}</p>
          </div>
        </div>

        <div class="form-actions">
          <div class="action-buttons">
            <button type="button" class="btn-ghost" @click="goHome">홈으로</button>
            <template v-if="reason === 'requires_login'">
              <button v-if="liveSlug" type="button" class="btn-ghost" @click="goLive">
                공연 페이지
              </button>
              <button type="button" class="submit-btn" @click="goSignIn">로그인하기</button>
            </template>
            <template v-else-if="reason === 'door_day_admin_only'">
              <button v-if="liveSlug" type="button" class="submit-btn" @click="goLive">공연 페이지</button>
            </template>
            <button v-else-if="liveSlug" type="button" class="submit-btn" @click="goLive">
              공연 페이지
            </button>
          </div>
        </div>
      </div>
    </paper-modal-container>
  </div>
</template>

<script>
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "../../../firebaseConfig";
import PaperModalContainer from "@/components/modal/PaperModalContainer.vue";

export default {
  name: "TicketReservationUnavailable",
  components: { PaperModalContainer },
  data() {
    return {
      liveTitleText: "",
      liveDateText: "",
      liveSlugValue: "",
    };
  },
  computed: {
    liveId() {
      return String(this.$route.params.id || "");
    },
    /** 라우트의 reason 쿼리 */
    reason() {
      return String(this.$route.query.reason || "");
    },
    /** 로그인 안내를 현장 등록 톤으로 표시할지 (`type=door`) */
    isDoorLoginContext() {
      const q = this.$route.query;
      const raw = q.type ?? q.Type;
      const v = Array.isArray(raw) ? raw[0] : raw;
      return String(v ?? "").trim().toLowerCase() === "door";
    },
    paperModalTitle() {
      if (this.reason === "door_day_admin_only") return "현장 예매 신청";
      if (this.reason === "requires_login" && this.isDoorLoginContext) return "현장 예매 신청";
      return "예매 신청서";
    },
    noticeIcon() {
      return "!";
    },
    noticeLabel() {
      if (this.reason === "requires_login") return "로그인 필요";
      if (this.reason === "door_day_admin_only") return "이용 시간 안내";
      return "안내";
    },
    headline() {
      if (this.reason === "closed") return "예매가 종료되었습니다";
      if (this.reason === "not_started") return "아직 예매 기간이 아닙니다";
      if (this.reason === "requires_login") {
        return this.isDoorLoginContext
          ? "현장 등록은 로그인 후 이용할 수 있습니다"
          : "예매 신청은 로그인 후 이용할 수 있습니다";
      }
      if (this.reason === "door_day_admin_only") return "현장 등록은 공연 당일에만 오픈됩니다";
      return "예매를 진행할 수 없습니다";
    },
    description() {
      if (this.reason === "closed") {
        return "이 공연의 예매 접수 기간이 종료되어 지금은 신청할 수 없습니다.";
      }
      if (this.reason === "not_started") {
        return "예매 시작 일시 이후에 다시 이용해 주세요.";
      }
      if (this.reason === "requires_login") {
        return this.isDoorLoginContext
          ? "현장 등록은 회원 로그인이 필요합니다. 로그인한 뒤 같은 링크로 다시 들어오거나, 예매관리에서 현장 등록을 진행해 주세요."
          : "사전 예매는 회원 로그인이 필요합니다. 로그인한 뒤 같은 공연 페이지에서 예매 신청을 다시 진행해 주세요.";
      }
      if (this.reason === "door_day_admin_only") {
        return "현장 등록은 공연 당일에만 신청할 수 있습니다. 공연일 이전 등록은 사전 예매를 이용해주세요.";
      }
      return "현재 이 공연은 예매 가능 기간이 아닙니다.";
    },
    liveTitle() {
      return this.liveTitleText.trim();
    },
    liveSlug() {
      return String(this.liveSlugValue || "").trim();
    },
  },
  async mounted() {
    if (!this.liveId) return;
    try {
      const snap = await getDoc(doc(firestore, "lives", this.liveId));
      if (!snap.exists()) return;
      const data = snap.data();
      this.liveTitleText = data?.title || "";
      this.liveDateText = typeof data?.date === "string" ? data.date.trim() : "";
      const slug = data?.slug;
      this.liveSlugValue = slug != null && slug !== "" ? String(slug) : this.liveId;
    } catch (e) {
      console.warn("공연 정보 로드 실패:", e);
    }
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    goBack() {
      if (this.liveSlug) {
        this.$router.push({ name: "LiveDetail", params: { slug: this.liveSlug } });
      } else {
        this.$router.push("/");
      }
    },
    goLive() {
      if (!this.liveSlug) {
        this.goHome();
        return;
      }
      this.$router.push({ name: "LiveDetail", params: { slug: this.liveSlug } });
    },
    goSignIn() {
      this.$router.push("/signin");
    },
  },
};
</script>

<style scoped>
/* TicketForm.vue 와 동일 계열 레이아웃·타이포 */
.form-wrapper {
  padding: 24px 0;
  text-align: left;
  max-width: 900px;
  margin: 0 auto;
  animation: slideUp 0.5s ease-out;
  font-family: "NanumSquareRoundR", sans-serif;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.preview-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-left: 4px solid #66bdff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  font-family: "NanumSquareRoundR", sans-serif;
  animation: fadeIn 0.5s ease-out;
}

.preview-notice-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  background: #66bdff;
  color: #fff;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
  font-family: "NanumSquareRoundEB", sans-serif;
}

.preview-notice-content {
  flex: 1;
  min-width: 0;
}

.preview-notice-label {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: #66bdff;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 4px;
  font-family: "NanumSquareRoundB", sans-serif;
}

.preview-notice-text {
  font-size: 14px;
  color: #2d3748;
  line-height: 1.5;
  margin: 0;
  font-family: "NanumSquareRoundEB", sans-serif;
}

.preview-notice-detail {
  font-size: 13px;
  color: #475569;
  line-height: 1.55;
  margin: 10px 0 0;
  font-family: "NanumSquareRoundR", sans-serif;
}

.form-section-block {
  padding: 32px 0;
  margin-bottom: 0;
  border-bottom: 1px solid #e9ecef;
  animation: fadeIn 0.5s ease-out backwards;
}

.form-section-block:last-of-type {
  border-bottom: none;
}

.section-header {
  margin-bottom: 24px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
  font-family: "NanumSquareRoundEB", sans-serif;
}

.section-description {
  font-size: 14px;
  color: #666;
  margin: 0;
  font-family: "NanumSquareRoundR", sans-serif;
}

.info-box {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  margin-top: 16px;
}

.info-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f1f3f5;
}

.info-row:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.info-label {
  flex: 0 0 120px;
  font-weight: 600;
  color: #495057;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 14px;
}

.info-value {
  flex: 1;
  color: #212529;
  font-family: "NanumSquareRoundR", sans-serif;
  font-size: 14px;
}

.form-actions {
  margin-top: 40px;
  text-align: center;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.submit-btn {
  padding: 14px 32px;
  background: #66bdff;
  color: white;
  border: none;
  border-radius: 8px;
  font-family: "NanumSquareRoundEB", sans-serif;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.submit-btn:hover {
  background: #4da3ff;
}

.btn-ghost {
  padding: 14px 28px;
  background: #fff;
  color: #495057;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-family: "NanumSquareRoundB", sans-serif;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-ghost:hover {
  background: #f8f9fa;
}

@media (max-width: 480px) {
  .form-wrapper {
    padding: 20px 12px;
  }

  .preview-notice {
    padding: 12px 14px;
    margin-bottom: 20px;
  }

  .form-section-block {
    padding: 24px 0;
  }

  .section-title {
    font-size: 17px;
  }

  .section-description {
    font-size: 13px;
  }

  .info-row {
    padding: 8px 0;
  }

  .info-label {
    flex: 0 0 80px;
    font-size: 12px;
  }

  .info-value {
    font-size: 13px;
  }

  .submit-btn,
  .btn-ghost {
    padding: 12px 22px;
    font-size: 14px;
  }

  .form-actions {
    margin-top: 28px;
  }
}
</style>
